import { render, staticRenderFns } from "./CalendarHome.vue?vue&type=template&id=4ba4cd9a&"
import script from "./CalendarHome.vue?vue&type=script&lang=ts&"
export * from "./CalendarHome.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarHome.vue?vue&type=style&index=0&id=4ba4cd9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports